/* Ganz Wien Tattoo – minimal image lightbox with zoom.
   Usage: <gallery-lightbox> inside an element with [data-lightbox-scope];
   every [data-lightbox-src] element in that scope opens the lightbox. */
(function () {
  if (customElements.get('gallery-lightbox')) return;

class GalleryLightbox extends HTMLElement {
  connectedCallback() {
    this.dialog = this.querySelector('dialog');
    this.stage = this.querySelector('.lightbox__stage');
    this.img = this.querySelector('.lightbox__image');
    this.counter = this.querySelector('.lightbox__counter');
    this.caption = this.querySelector('.lightbox__caption');
    const scope = this.closest('[data-lightbox-scope]') || this.parentElement;
    this.items = Array.from(scope.querySelectorAll('[data-lightbox-src]'));
    this.index = 0;
    this.reset();

    this.items.forEach((el, i) => {
      el.addEventListener('click', (e) => { e.preventDefault(); this.open(i); });
    });
    this.querySelector('.lightbox__close').addEventListener('click', () => this.close());
    this.querySelector('.lightbox__prev').addEventListener('click', () => this.go(-1));
    this.querySelector('.lightbox__next').addEventListener('click', () => this.go(1));
    this.querySelector('.lightbox__zoom-in').addEventListener('click', () => this.zoom(1.5));
    this.querySelector('.lightbox__zoom-out').addEventListener('click', () => this.zoom(1 / 1.5));

    this.dialog.addEventListener('click', (e) => {
      if (e.target === this.dialog || e.target === this.stage) this.close();
    });
    this.dialog.addEventListener('close', () => {
      document.body.classList.remove('overflow-hidden');
      if (this.opener) this.opener.focus();
    });
    this.dialog.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') this.go(1);
      if (e.key === 'ArrowLeft') this.go(-1);
      if (e.key === '+' || e.key === '=') this.zoom(1.5);
      if (e.key === '-') this.zoom(1 / 1.5);
    });

    this.img.addEventListener('dblclick', (e) => {
      if (this.scale > 1) this.reset();
      else this.zoomTo(2.5, e.clientX, e.clientY);
    });
    this.stage.addEventListener('wheel', (e) => {
      e.preventDefault();
      this.zoomTo(this.scale * (e.deltaY < 0 ? 1.2 : 1 / 1.2), e.clientX, e.clientY);
    }, { passive: false });

    // pointer handling: one finger drags when zoomed (or swipes when not), two fingers pinch
    const pointers = new Map();
    let pinch = null;
    let drag = null;
    this.stage.addEventListener('pointerdown', (e) => {
      if (e.target !== this.img) return;
      pointers.set(e.pointerId, e);
      if (pointers.size === 1) drag = { x: e.clientX, y: e.clientY, tx: this.tx, ty: this.ty, moved: false };
    });
    this.stage.addEventListener('pointermove', (e) => {
      if (!pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, e);
      if (pointers.size === 2) {
        const [a, b] = Array.from(pointers.values());
        const d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
        if (!pinch) pinch = { d, scale: this.scale };
        else this.setScale(pinch.scale * (d / pinch.d));
        drag = null;
      } else if (drag) {
        const dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) drag.moved = true;
        if (this.scale > 1) { this.tx = drag.tx + dx; this.ty = drag.ty + dy; this.apply(); }
      }
    });
    const end = (e) => {
      pointers.delete(e.pointerId);
      if (pointers.size < 2) pinch = null;
      if (drag && pointers.size === 0) {
        const dx = e.clientX - drag.x;
        if (this.scale === 1 && Math.abs(dx) > 60) this.go(dx < 0 ? 1 : -1);
        drag = null;
      }
    };
    this.stage.addEventListener('pointerup', end);
    this.stage.addEventListener('pointercancel', end);
  }

  open(i) {
    this.opener = this.items[i];
    this.index = i;
    this.show();
    if (!this.dialog.open) this.dialog.showModal();
    document.body.classList.add('overflow-hidden');
  }
  close() { if (this.dialog.open) this.dialog.close(); }
  go(step) {
    if (this.items.length < 2) return;
    this.index = (this.index + step + this.items.length) % this.items.length;
    this.show();
  }
  show() {
    const el = this.items[this.index];
    this.reset();
    this.img.src = el.dataset.lightboxSrc;
    if (el.dataset.lightboxSrcset) this.img.srcset = el.dataset.lightboxSrcset; else this.img.removeAttribute('srcset');
    this.img.alt = el.dataset.lightboxAlt || '';
    this.caption.textContent = el.dataset.lightboxAlt || '';
    this.counter.textContent = this.items.length > 1 ? `${this.index + 1} / ${this.items.length}` : '';
    this.classList.toggle('lightbox--single', this.items.length < 2);
  }
  setScale(s) { this.scale = Math.min(5, Math.max(1, s)); if (this.scale === 1) { this.tx = 0; this.ty = 0; } this.apply(); }
  zoom(f) { this.setScale(this.scale * f); }
  zoomTo(s, cx, cy) {
    const r = this.img.getBoundingClientRect();
    const prev = this.scale;
    const next = Math.min(5, Math.max(1, s));
    if (next === 1) { this.reset(); return; }
    // keep the point under the cursor fixed
    const ox = cx - (r.left + r.width / 2), oy = cy - (r.top + r.height / 2);
    this.tx = this.tx - ox * (next / prev - 1);
    this.ty = this.ty - oy * (next / prev - 1);
    this.scale = next;
    this.apply();
  }
  reset() { this.scale = 1; this.tx = 0; this.ty = 0; this.apply(); }
  apply() {
    this.img.style.transform = `translate(${this.tx}px, ${this.ty}px) scale(${this.scale})`;
    this.img.classList.toggle('is-zoomed', this.scale > 1);
  }
}
customElements.define('gallery-lightbox', GalleryLightbox);
})();
